var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('UserBnxgnBind',{directives:[{name:"show",rawName:"v-show",value:(_vm.query.resultText),expression:"query.resultText"}],attrs:{"query":_vm.query}}),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.bindHref),expression:"bindHref"}]},[_c('app-header',{attrs:{"title":_vm.title}}),_c('form-entity',{staticClass:"form-edit",attrs:{"model":_vm.userModel,"rules":_vm.rules}},[_c('form-field',{attrs:{"prop":"code","default-focus":false,"options":{ label: '暴虐:Code', readonly: true, placeholder: '暴虐新概念Code', type: 'text', required: true }}}),_c('form-field',{attrs:{"prop":"openId","default-focus":false,"options":{
          label: '暴虐:OpenID',
          readonly: true,
          placeholder: '暴虐新概念OpenID',
          type: 'text',
          required: true
        }}}),_c('form-field',{attrs:{"prop":"userId","default-focus":true,"options":{
          label: '暴虐:UserID',
          readonly: true,
          placeholder: '暴虐新概念UserID',
          type: 'text',
          required: true
        }}}),_c('form-field',{attrs:{"prop":"mobileNumber","options":{
          label: '手机号码',
          readonly: true,
          placeholder: '手机号码',
          type: 'tel',
          format: 'phone',
          required: true
        }}}),_c('form-field',{attrs:{"prop":"bindHref","options":{ label: '绑定地址', readonly: true, placeholder: '绑定地址', type: 'text', required: true }}}),_c('div',{staticClass:"action-btns"},[(_vm.bindHref)?_c('mt-button',{on:{"click":_vm.doBindHref}},[_vm._v("登录并领取权益")]):_vm._e(),(_vm.bindResult.havePrivilege === -1)?_c('mt-button',{on:{"click":_vm.toLogin}},[_vm._v("获取公众号授权")]):_vm._e()],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }